<div class="sort-by-select">
  <div class="title" [class.active]="isSortByOpen">{{ titleText }}</div>
  <ng-select [items]="selectedProperties" bindLabel="name" bindValue="name" [(ngModel)]="gridItem.setup[sortByPropertyName]" placeholder="{{ 'Select'| i18next }}"
             [class.active]="isSortByOpen" (focus)="isSortByOpen=true" (blur)="isSortByOpen=false" [searchable]="false" (change)="sortByChanged()">
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
      {{ 'dashboard:'+ item.name | i18next }}
    </ng-template>
    <ng-template ng-label-tmp let-item="item">
      <span class="item">
        <span>{{ 'dashboard:'+ item?.name | i18next }}</span>      
        <span><i class="far fa-times-circle" (click)="sortByClear()"></i></span>
      </span>
    </ng-template>
  </ng-select>
</div>
<div class="sort-direction-select" *ngIf="gridItem.setup[sortByPropertyName]">
  <input type="radio" [attr.name]="radioButtonName" [attr.id]="radioButtonAscId" (change)="sortDirectionChanged($event)" [value]="0" [checked]="gridItem.setup[sortDirectionPropertyName] == 0" />
  <label [attr.for]="radioButtonAscId">{{ 'dashboard:Ascending' | i18next }}</label>
  <input type="radio" [attr.name]="radioButtonName" [attr.id]="radioButtonDescId" (change)="sortDirectionChanged($event)" [value]="1" [checked]="gridItem.setup[sortDirectionPropertyName] == 1" />
  <label [attr.for]="radioButtonDescId">{{ 'dashboard:Descending' | i18next }}</label>
</div>
